<template>
    <v-container style="min-height:85vh;" fluid>
        <!-- <h3 class="ma-3">Podemos colocar um header aqui ou um breadcrumbs</h3> -->
        <router-view></router-view>		
    </v-container>
</template>

<script>
export default {
  name: 'Container',
}
</script>